import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LoadingSpinner from '../components/LoadingSpinner';
import Background from '../components/Background';
import { ColourStyleEnum, FontStyleEnum } from '../models/api';
import { PageDetails, SessionBackgroundData } from './Session';
import { getData } from '../services/api';
import Introduction from './Introduction';

interface DataResponse {
  colourStyleEnum: ColourStyleEnum;
  fontStyleEnum: FontStyleEnum;
  background: SessionBackgroundData | null;
  sessionName: string;
  welcomeImageUrl: string | null;
  iconUrl: string | null;
  aboutPage: PageDetails;
}

const PreviewStart = () => {
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState<string[]>([]);
  const [data, setData] = useState<DataResponse | null>();
  const { reference } = useParams();

  useEffect(() => {
    const get = async () => {
      setLoading(true);

      const result = await getData<DataResponse>(
        `api/sessions/${reference}/preview/start`
      );
      if (result.success && result.data) {
        setData(result.data);
      }
      if (!result.success) {
        setErrors(result.errors);
      }
      setLoading(false);
    };

    if (reference) {
      get();
    }
  }, []);

  const getStyleClass = () => {
    const g = data?.colourStyleEnum
      ? `color-style-${data.colourStyleEnum}`
      : '';
    const t = data?.fontStyleEnum ? ` font-style-${data.fontStyleEnum}` : '';

    return 'content-page ' + g + t;
  };

  if (loading || !data) {
    return (
      <>
        <LoadingSpinner />
      </>
    );
  }
  return (
    <div className={getStyleClass()}>
      <Background background={data.background} />
      <Introduction
        sessionName={data.sessionName}
        welcomeImageUrl={data.welcomeImageUrl}
        iconUrl={data.iconUrl}
        location={''}
        startDateUtc={''}
        isPresenting={true}
        allowReview={false}
        chooseResume={false}
        startAction={() => {
          /* Do nothing */
        }}
        setShowHowThisWorks={() => {
          /* Do nothing */
        }}
        setShowAbout={() => {
          /* Do nothing */
        }}
        showAboutAvailable={!!data.aboutPage}
        viewHistoricAction={() => {
          /* Do nothing */
        }}
        isDefault={true}
      />
    </div>
  );
};

export default PreviewStart;
